import {Component, OnInit} from '@angular/core';
import {AccountService} from '../../services/account.service';
import {BankPolicy, BankPolicyInsurerRating, PersonBank, PersonBankPolicy} from '../../models/bank-policy-group';
import {BankOption} from '../../models/bank-option';
import {PaymentDetails} from '../../models/payment-details';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {PersonBankAccountGroup, PersonBankAccountPaymentDetails} from '../../models/person-bank-account';
import {PaymentDetailsTransactionTypes} from '../../models/enums/payment-details-transaction-types';
import {CreditCardValidators} from 'angular-cc-library';
import { GlobalQuestionService } from 'src/app/modules/shared/services/global-question.service';
import { Alert } from 'src/app/modules/shared/utilities';
import { PolicyQuery } from 'src/app/modules/policy/state/policy.query';
import { Policy } from 'src/app/modules/shared/models/policy.model';

declare const $: any;

@Component({
    selector: 'app-payment-details',
    templateUrl: './payment-details.component.html',
    styleUrls: ['./payment-details.component.scss'],
    standalone: false
})
export class PaymentDetailsComponent implements OnInit {

  user: any;
  bankPolicies: BankPolicy[] = [];
  dropdownBanks = [];
  bankOptions: BankOption[] = [];
  selectedDropdownBank: BankOption;
  bankDetails = new PaymentDetails();
  debitOrderForm: FormGroup;
  creditCardForm: FormGroup;
  editDebitOrderForm: FormGroup;
  editCreditCardForm: FormGroup;
  submitted = false;
  editSubmitted = false;
  personBankAccounts: PersonBankAccountGroup[] = [];
  selectedPolicy: PersonBankPolicy;
  selectedBank: PersonBank;
  selectedEditBankAccount: PersonBankAccountPaymentDetails;
  selectedEditBankAccountPolicies: PersonBankPolicy[] = [];
  newPolicyBank: PersonBankAccountPaymentDetails;
  newPaymentMethodTransactionType = PaymentDetailsTransactionTypes.Debit_Order;
  PaymentDetailsTransactionTypes = PaymentDetailsTransactionTypes;
  accountTypes: any[] = [
    {value: '1', label: 'Current Account'},
    {value: '2', label: 'Savings Account'},
    {value: '3', label: 'Credit Card Account'},
    {value: '4', label: 'Transaction Account'},
  ];
  newPaymentButtonDisabled = true;
  editPaymentButtonDisabled = true;
  bankPoliciesLoaded = false;
 person_id = 0;
  constructor(private accountService: AccountService, 
    private fb: FormBuilder,
    public globalQuestionService: GlobalQuestionService,
    private policyQuery: PolicyQuery) { }

  ngOnInit(): void {
    this.bankDetails.person_bank_id = 0;
    try{
      const policy = this.policyQuery.getActive();

      let tempPolicy: Policy;
      if (Array.isArray(policy)) {
        tempPolicy = Object.assign({}, policy[0]);
      } else {
        tempPolicy = Object.assign({}, policy);
      }
      this.person_id = tempPolicy?.person[0].person_id;
    }
    catch{}
    this.createForms();
    this.getBankPolicies();
    this.getBanks();
  }

  getBankPolicies(): void {
    this.accountService.getBankPolicy(this.person_id)
      .subscribe({
        next: value => {
          if (value?.length && value[0]?.json) {
            this.bankPolicies = JSON.parse(value[0]?.json);
            if (this.bankPolicies?.length) {
              for (const bp of this.bankPolicies) {
                if (bp?.person_banks?.length) {
                  // Deduplicate person_banks by person_bank_id, merging their policies
                  const bankMap = new Map<number, any>();
                  for (const b of bp.person_banks) {
                    const existing = bankMap.get(b?.person_bank_id);
                    if (existing) {
                      existing.policies = [...(existing.policies || []), ...(b.policies || [])];
                    } else {
                      bankMap.set(b?.person_bank_id, { ...b });
                    }
                  }
                  bp.person_banks = Array.from(bankMap.values());

                  for (const b of bp.person_banks) {
                    if (b?.policies?.length) {
                      // Deduplicate policies by policy_id + session_id
                      const seen = new Set<string>();
                      b.policies = b.policies.filter((p: any) => {
                        const key = `${p?.policy_id}_${p?.session_id}`;
                        if (seen.has(key)) return false;
                        seen.add(key);
                        return true;
                      });
                      for (const p of b.policies) {
                        if (p?.insurer_rating) {
                          p.insurer_rating_parsed = JSON.parse(p?.insurer_rating);
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          this.bankPoliciesLoaded = true;
        },
        error: () => {
          this.bankPoliciesLoaded = true;
        }
      });
  }

  getBanks(): void {
    this.accountService.getBanks()
      .subscribe({
        next: banks => {
          this.bankOptions = banks;
          if (this.bankOptions?.length) {
            for (const b of this.bankOptions) {
              this.dropdownBanks.push({value: b?.bank_id, label: b?.bank_name});
              if (b?.branches) {
                b.branches_parsed = JSON.parse(b?.branches);
              }
            }
          }
        }
      });
  }

  openChangeBankAccount(policy: PersonBankPolicy, bank: PersonBank): void {
    this.selectedPolicy = policy;
    this.selectedBank = bank;
    this.getPersonBankAccounts();
  }

  closeChangeBankAccount(): void {
    this.selectedPolicy = null;
    this.selectedBank = null;
    this.getPersonBankAccounts();
  }

  savePolicyNewBank(): void {
    this.accountService.savePolicyNewBank(this.newPolicyBank?.person_bank_id, this.selectedPolicy?.policy_id)
      .subscribe({
        next: () => {
          this.getBankPolicies();
          this.selectedPolicy = null;
          this.selectedBank = null;
          this.newPolicyBank = null;
        }
      });
  }

  openEditPaymentModel(bank: PersonBank): void {
    this.selectedBank = bank;
    console.log(this.selectedBank)
    for (const bp of this.bankPolicies) {
      for (const b of bp?.person_banks) {
        if (b?.person_bank_id === bank?.person_bank_id) {
          this.selectedEditBankAccountPolicies = b?.policies;
        }
      }
    }
    this.getPersonBankAccounts();
  }

  editBankAccountDetails(bank: PersonBankAccountPaymentDetails): void {
   
    if (bank) {
      this.selectedEditBankAccount = bank;
      for (const bp of this.bankPolicies) {
        for (const b of bp?.person_banks) {
          if (b?.person_bank_id === bank?.person_bank_id) {
            this.selectedEditBankAccountPolicies = b?.policies;
          }
        }
      }
      if (bank?.transaction_type === PaymentDetailsTransactionTypes.Debit_Order) {
        this.editDebitOrderForm.get('bank').setValue(bank.bank_name);
        this.editDebitOrderForm.get('branchCode').setValue(bank.branch_code);
        this.editDebitOrderForm.get('accountType').setValue(bank.acc_type);
        this.editDebitOrderForm.get('accountName').setValue(bank.acc_name);
        this.editDebitOrderForm.get('accountNumber').setValue(bank.acc_no);
      } else if (bank?.transaction_type === PaymentDetailsTransactionTypes.Credit_Debit_Card) {
        this.editCreditCardForm.get('name').setValue(bank?.card_name);
        this.editCreditCardForm.get('cardNumber').setValue(bank?.card_no);
        this.editCreditCardForm.get('expiry').setValue(bank?.card_exp);
        this.editCreditCardForm.get('cvv').setValue(bank?.card_cvv);
      }
      setTimeout(() => {
        $('#edit-payment-detail').modal('show');
        this.editPaymentButtonDisabled = false;
      }, 500);
    }
  }

  saveEditPaymentDetails(): void {
    if (this.selectedEditBankAccount?.transaction_type === PaymentDetailsTransactionTypes.Debit_Order) {
      this.selectedEditBankAccount.acc_name = this.editDebitOrderForm.get('accountName').value;
      this.selectedEditBankAccount.acc_no = this.editDebitOrderForm.get('accountNumber').value;
      this.accountService.savePersonBank(JSON.stringify(this.selectedEditBankAccount), this.person_id)
        .subscribe({
          next: () => {
            this.selectedEditBankAccount = null;
            this.editSubmitted = false;
            this.getBankPolicies();
          }
        });
    } else if (this.selectedEditBankAccount?.transaction_type === PaymentDetailsTransactionTypes.Credit_Debit_Card && this.editCreditCardForm.valid) {
      this.selectedEditBankAccount.card_name = this.editCreditCardForm.get('name').value;
      this.selectedEditBankAccount.card_no = this.editCreditCardForm.get('cardNumber').value?.replace(/\s/g, '');
      this.selectedEditBankAccount.card_exp = this.editCreditCardForm.get('expiry').value?.replace(/\s/g, '');
      this.selectedEditBankAccount.card_cvv = this.editCreditCardForm.get('cvv').value;
      this.accountService.savePersonBank(JSON.stringify(this.selectedEditBankAccount), this.person_id)
        .subscribe({
          next: () => {
            this.selectedEditBankAccount = null;
            this.editSubmitted = false;
          }
        });
    }
  }

  openAddNewPaymentModal(): void {
    this.selectedEditBankAccount = null;
    setTimeout(() => {
      $('#add-new-payment-modal').modal('show');
    }, 500);
  }

  continueToConfirmModal(): void {
    this.globalQuestionService.spinner(true);
    this.globalQuestionService.validateBankAccount(this.editDebitOrderForm.value.accountNumber,this.editDebitOrderForm.value.branchCode,this.editDebitOrderForm.value.accountType.toString()).subscribe( val => {
      this.globalQuestionService.spinner(false);
      switch (val) {
        case '0': 
        setTimeout(() => {
          $('#edit-payment-detail').modal('hide');
          if (this.selectedEditBankAccountPolicies?.length){
            $('#confirm-update-modal').modal('show');
          }
        }, 500);
        break;
        default:
          setTimeout(() => {
            $('#edit-payment-detail').modal('show');
          }, 500);
          
          Alert('We are unable to verify the details you have entered. Please call or chat to us for further assistance.');
          break;

      }
    })
    
  }

  continueToConfirmModalFromTransferModal(): void {
    setTimeout(() => {
      $('#transfer-confirm-update-modal').modal('show');
    }, 500);
  }

  saveTransferPoliciesBank(): void {
    this.accountService.savePolicyBankTransfer(this.selectedBank?.person_bank_id, this.newPolicyBank?.person_bank_id)
      .subscribe({
        next: () => {
          this.getBankPolicies();
          this.selectedBank = null;
          this.newPolicyBank = null;
        }
      });
  }

  getPersonBankAccounts(): void {
    this.accountService.getPersonBankAccounts( this.person_id)
      .subscribe({
        next: accounts => {
          if (accounts?.length && accounts[0]?.json) {
            this.personBankAccounts = JSON.parse(accounts[0]?.json);
          }
        }
      });
  }

  createForms(): void {
    this.debitOrderForm = this.fb.group({
      bank: ['', Validators.required],
      branchCode: ['', Validators.required],
      accountType: ['', Validators.required],
      accountName: ['', Validators.required],
      accountNumber: ['', Validators.required],
    });

    this.creditCardForm = this.fb.group({
      name: ['', Validators.required],
      cardNumber: ['', [CreditCardValidators.validateCCNumber]],
      expiry: ['', [CreditCardValidators.validateExpDate]],
      cvv: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(4)]]
    });

    this.editDebitOrderForm = this.fb.group({
      bank: ['', Validators.required],
      branchCode: ['', Validators.required],
      accountType: ['', Validators.required],
      accountName: ['', Validators.required],
      accountNumber: ['', Validators.required],
    });

    this.editCreditCardForm = this.fb.group({
      name: ['', Validators.required],
      cardNumber: ['', [CreditCardValidators.validateCCNumber]],
      expiry: ['', [CreditCardValidators.validateExpDate]],
      cvv: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(4)]]
    });
    this.checkFormChanges();
  }

  checkFormChanges(): void {
    this.debitOrderForm.valueChanges.subscribe({
      next: () => {
        this.newPaymentButtonDisabled = !this.debitOrderForm.valid;
      }
    });
    this.creditCardForm.valueChanges.subscribe({
      next: () => {
        this.newPaymentButtonDisabled = !this.creditCardForm.valid;
      }
    });
    this.editDebitOrderForm.valueChanges.subscribe({
      next: () => {
        this.editPaymentButtonDisabled = this.editDebitOrderForm.valid;
      }
    });
    this.editCreditCardForm.valueChanges.subscribe({
      next: () => {
        this.editPaymentButtonDisabled = !this.editCreditCardForm.valid;
      }
    });
  }

  changeBank(event: number): void {
    if (this.selectedEditBankAccount) {
      if (event) {
        const selectedDropdownBank = this.bankOptions?.find(b => b?.bank_id === +event);
        this.selectedEditBankAccount.bank_id = selectedDropdownBank?.bank_id;
        this.selectedEditBankAccount.bank_name = selectedDropdownBank?.bank_name;
        this.editDebitOrderForm.get('bank').setValue(this.selectedEditBankAccount?.bank_name);

        if (selectedDropdownBank?.branches_parsed?.length) {
          const branch = selectedDropdownBank?.branches_parsed?.find(b => b?.universal === 1);
          if (branch) {
            this.selectedEditBankAccount.branch_code = branch?.branch_code;
            this.selectedEditBankAccount.branch_id = branch?.branch_id;
            this.editDebitOrderForm.get('branchCode').setValue(this.selectedEditBankAccount?.branch_code);
          } else {
            this.selectedEditBankAccount.branch_id = null;
          }
        }
      } else {
        this.selectedEditBankAccount.bank_id = null;
        this.selectedEditBankAccount.bank_name = null;
      }
    } else {
      if (event) {
        this.selectedDropdownBank = this.bankOptions?.find(b => b?.bank_id === +event);
        this.bankDetails.bank_id = this.selectedDropdownBank?.bank_id;
        this.bankDetails.bank_name = this.selectedDropdownBank?.bank_name;
        this.debitOrderForm.get('bank').setValue(this.bankDetails?.bank_name);

        if (this.selectedDropdownBank?.branches_parsed?.length) {
          const branch = this.selectedDropdownBank?.branches_parsed?.find(b => b?.universal === 1);
          if (branch) {
            this.bankDetails.branch_code = branch?.branch_code;
            this.bankDetails.branch_id = branch?.branch_id;
            this.debitOrderForm.get('branchCode').setValue(this.bankDetails?.branch_code);
          } else {
            this.bankDetails.branch_id = null;
          }
        }
      } else {
        this.selectedDropdownBank = null;
        this.bankDetails.bank_id = null;
        this.bankDetails.bank_name = null;
      }
    }
  }

  changeAccountType(event: any): void {
    if (this.selectedEditBankAccount) {
      if (event) {
        this.selectedEditBankAccount.acc_type = event.toString();
      } else {
        this.selectedEditBankAccount.acc_type = 0;
      }
      this.editDebitOrderForm.get('accountType').setValue(this.selectedEditBankAccount?.acc_type);
    } else {
      if (event) {
        this.bankDetails.acc_type = event.toString();
      } else {
        this.bankDetails.acc_type = '0';
      }
      this.debitOrderForm.get('accountType').setValue(this.bankDetails.acc_type);
    }
  }

  submitNewPaymentMethod(): void {
    this.submitted = true;
    if (this.newPaymentMethodTransactionType === PaymentDetailsTransactionTypes.Debit_Order && this.debitOrderForm.valid) {
      this.bankDetails.acc_name = this.debitOrderForm.get('accountName').value;
      this.bankDetails.acc_no = this.debitOrderForm.get('accountNumber').value;
      console.log(this.bankDetails);
      this.globalQuestionService.spinner(true);
      this.globalQuestionService.validateBankAccount(this.bankDetails.acc_no, this.bankDetails.branch_code.toString(), this.bankDetails.acc_type).subscribe( val => {
        this.globalQuestionService.spinner(false);
        switch (val) {
          case '0': 
          $('.modal'). modal('hide');
          this.bankDetails.transaction_type = PaymentDetailsTransactionTypes.Debit_Order;
          this.accountService.savePersonBank(JSON.stringify(this.bankDetails), this.person_id)
            .subscribe({
              next: () => {
                //this.bankDetails = new PaymentDetails();
                this.getBankPolicies();
              }
            });
          break;
          default:
            Alert('We are unable to verify the details you have entered. Please call or chat to us for further assistance.');
            break;
  
        }
        this.globalQuestionService.spinner(false);
      })
      return;
      
     
    } else if (this.newPaymentMethodTransactionType === PaymentDetailsTransactionTypes.Credit_Debit_Card && this.creditCardForm.valid) {
      this.bankDetails.card_name = this.creditCardForm.get('name').value;
      this.bankDetails.card_no = this.creditCardForm.get('cardNumber').value?.replace(/\s/g, '');
      this.bankDetails.card_exp = this.creditCardForm.get('expiry').value?.replace(/\s/g, '');
      this.bankDetails.card_cvv = this.creditCardForm.get('cvv').value;
      this.bankDetails.transaction_type = PaymentDetailsTransactionTypes.Credit_Debit_Card;
      this.accountService.savePersonBank(JSON.stringify(this.bankDetails), this.person_id)
        .subscribe({
          next: () => {
            this.bankDetails = new PaymentDetails();
            this.getPersonBankAccounts();
          }
        });
    }
  }

  getStarPercent(ratings: BankPolicyInsurerRating[]): any[] {
    if (ratings?.length) {
      return ratings[0].star_css.split('|');
    }
    return [];
  }

}
